import { ChartDerivedMeasure, ChartPlugin } from '../_types'


const workingMode: ChartDerivedMeasure<'bypSel' | 'drvSel' | 'workingMode'> = {
  slug: 'workingMode',
  representation: 'time-bar',
  derivationFn: measuresData => {
    if (measuresData.drvSel) {
      return 0
    }
    if (measuresData.bypSel) {
      return 1
    }
    return null
  },
}


const bunkerWorkingModePlugin: ChartPlugin = {
  derivedMeasures: [workingMode],
  measures: [
    {
      slug: 'bypSel',
      id: 'BS_BYP_SEL',
      representation: null,
    },
    {
      slug: 'drvSel',
      id: 'BS_DRV_SEL',
      representation: null,
    },
  ],
}

export default bunkerWorkingModePlugin
